/* ============================================================
   CORMU — carrito de COTIZACIÓN (no de compra)

   Por qué no se usa el carrito de Shopify: en este sitio no se publican
   precios y todos los productos están en $0. Si el cliente llegara al
   checkout compraría en cero. Esta lista vive en el navegador y termina
   en un WhatsApp, que es donde de verdad se cierra la venta mayorista.
   ============================================================ */
(function () {
  "use strict";

  var LLAVE = "cormu_cotizacion_v1";
  var cfg = window.CORMU_COT_CFG || {};
  var lista = {};

  try { lista = JSON.parse(localStorage.getItem(LLAVE)) || {}; } catch (e) { lista = {}; }

  function guardar() {
    try { localStorage.setItem(LLAVE, JSON.stringify(lista)); } catch (e) {}
    pintar();
  }
  function cuantos() { return Object.keys(lista).length; }

  function agregar(sku, datos) {
    if (lista[sku]) { lista[sku].cant += 1; }
    else { lista[sku] = { cant: 1, nombre: datos.nombre, img: datos.img, url: datos.url }; }
    guardar();
    avisar("Agregado a tu cotización");
  }
  function quitar(sku) { delete lista[sku]; guardar(); }
  function cantidad(sku, n) {
    n = Math.max(1, parseInt(n, 10) || 1);
    if (lista[sku]) { lista[sku].cant = n; guardar(); }
  }

  /* ---------------- interfaz ---------------- */
  function nodo(html) {
    var d = document.createElement("div"); d.innerHTML = html.trim(); return d.firstChild;
  }

  var velo, panel, cuerpo, pie, contadorEls;

  function construir() {
    velo = nodo('<div class="cmu-velo"></div>');
    panel = nodo(
      '<aside class="cmu-drawer" aria-label="Cotización">' +
        '<div class="cmu-dw-h"><h3>Tu cotización <span class="cmu-n">(<span data-cot-n>0</span>)</span></h3>' +
        '<button type="button" data-a="cerrar" aria-label="Cerrar">' +
        '<svg width="18" height="18" viewBox="0 0 24 24" stroke="currentColor" stroke-width="1.9" fill="none"><path d="M5 5l14 14M19 5L5 19"/></svg>' +
        "</button></div>" +
        '<div class="cmu-dw-b"></div>' +
        '<div class="cmu-dw-f">' +
          '<p class="cmu-nota">' + (cfg.nota || "Le respondemos con la lista de precios mayorista y la disponibilidad exacta. No publicamos precios en el sitio.") + "</p>" +
          '<button class="cmu-btn primario" style="width:100%" type="button" data-a="enviar">' +
            '<svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor"><path d="M12 2a10 10 0 00-8.6 15l-1.3 4.7 4.8-1.3A10 10 0 1012 2zm5.5 14.1c-.2.6-1.3 1.2-1.8 1.2-.5.1-1 .1-1.7-.1-.4-.1-.9-.3-1.5-.6-2.6-1.1-4.3-3.8-4.5-4-.1-.2-1-1.4-1-2.6s.6-1.8.9-2.1c.2-.2.5-.3.7-.3h.5c.2 0 .4 0 .6.5l.8 2c.1.2.1.3 0 .5l-.3.4-.3.3c-.1.1-.2.3 0 .5.1.2.6 1 1.3 1.6.9.8 1.6 1 1.9 1.2.2.1.4.1.5-.1l.7-.8c.2-.2.3-.2.5-.1l2 .9c.2.1.4.2.4.3.1.2.1.6-.1 1z"/></svg>' +
            " Enviar por WhatsApp</button>" +
        "</div>" +
      "</aside>");
    document.body.appendChild(velo);
    document.body.appendChild(panel);
    cuerpo = panel.querySelector(".cmu-dw-b");
    pie = panel.querySelector(".cmu-dw-f");

    velo.addEventListener("click", function () { abrir(false); });
    panel.addEventListener("click", function (e) {
      var b = e.target.closest("[data-a]"); if (!b) return;
      if (b.dataset.a === "cerrar") abrir(false);
      if (b.dataset.a === "enviar") enviar();
      var fila = b.closest("[data-sku]");
      if (!fila) return;
      var sku = fila.dataset.sku;
      if (b.dataset.a === "x") quitar(sku);
      if (b.dataset.a === "+") cantidad(sku, lista[sku].cant + 1);
      if (b.dataset.a === "-") cantidad(sku, lista[sku].cant - 1);
    });
    panel.addEventListener("change", function (e) {
      if (e.target.dataset.a === "q") cantidad(e.target.closest("[data-sku]").dataset.sku, e.target.value);
    });
    document.addEventListener("keydown", function (e) { if (e.key === "Escape") abrir(false); });
  }

  function abrir(v) {
    panel.classList.toggle("on", v);
    velo.classList.toggle("on", v);
    document.body.style.overflow = v ? "hidden" : "";
  }

  function pintar() {
    contadorEls = document.querySelectorAll("[data-cot-n]");
    Array.prototype.forEach.call(contadorEls, function (el) {
      el.textContent = cuantos();
      var burbuja = el.closest("[data-cot-burbuja]");
      if (burbuja) burbuja.style.display = cuantos() ? "" : "none";
    });
    if (!cuerpo) return;

    var skus = Object.keys(lista);
    if (!skus.length) {
      cuerpo.innerHTML =
        '<div class="cmu-vacio">' +
        '<svg width="46" height="46" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.3"><path d="M3 6h18l-2 12H5L3 6zM3 6L2.2 3H0.5"/><circle cx="9" cy="21" r="1"/><circle cx="17" cy="21" r="1"/></svg>' +
        "<p>Tu cotización está vacía.</p>" +
        '<p class="chico">Agrega referencias desde el catálogo y te enviamos la lista de precios mayorista.</p></div>';
      pie.style.display = "none";
      return;
    }
    pie.style.display = "";
    cuerpo.innerHTML = skus.map(function (sku) {
      var it = lista[sku];
      return '<div class="cmu-dw-item" data-sku="' + sku + '">' +
        '<div class="im">' + (it.img ? '<img src="' + it.img + '" alt="">' : "") + "</div>" +
        '<div style="flex:1">' +
          '<div class="n">' + it.nombre + "</div>" +
          '<div class="s">SKU ' + sku + "</div>" +
          '<div class="q">' +
            '<button type="button" data-a="-">–</button>' +
            '<input type="text" inputmode="numeric" value="' + it.cant + '" data-a="q" aria-label="Cantidad">' +
            '<button type="button" data-a="+">+</button>' +
            '<button type="button" class="del" data-a="x">Quitar</button>' +
          "</div>" +
        "</div></div>";
    }).join("");
  }

  function enviar() {
    var tel = (cfg.whatsapp || "").replace(/[^0-9]/g, "");
    var lineas = Object.keys(lista).map(function (sku) {
      return "• " + lista[sku].nombre + " (SKU " + sku + ") x" + lista[sku].cant;
    });
    var texto = (cfg.saludo || "Hola, vengo de cormutrading.com y quiero cotizar:") + "\n\n" + lineas.join("\n");
    if (!tel) {
      avisar("Falta configurar el WhatsApp en el tema");
      return;
    }
    window.open("https://wa.me/" + tel + "?text=" + encodeURIComponent(texto), "_blank");
  }

  /* ---------------- aviso ---------------- */
  var toast, reloj;
  function avisar(msg) {
    if (!toast) {
      toast = nodo('<div class="cmu-toast"><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4"><path d="M4 12.5l5 5L20 6.5"/></svg><span></span></div>');
      document.body.appendChild(toast);
    }
    toast.querySelector("span").textContent = msg;
    toast.classList.add("on");
    clearTimeout(reloj);
    reloj = setTimeout(function () { toast.classList.remove("on"); }, 2200);
  }

  /* ---------------- arranque ---------------- */
  document.addEventListener("DOMContentLoaded", function () {
    construir();
    pintar();

    document.addEventListener("click", function (e) {
      var b = e.target.closest("[data-a]");
      if (!b) return;

      if (b.dataset.a === "abrir-cot") { abrir(true); return; }

      var card = b.closest("[data-sku]");
      if (!card || b.closest(".cmu-drawer")) return;

      // elegir color EN LA TARJETA: cambia la foto grande sin entrar al producto
      // y deja ese color como el que se va a cotizar.
      if (b.dataset.a === "color") {
        if (b.classList.contains("on")) return;
        var foto = card.querySelector(".cmu-card-img img");
        if (foto && b.dataset.img) {
          foto.src = b.dataset.img;
          foto.removeAttribute("srcset");
          foto.removeAttribute("sizes");
        }
        card.dataset.sku = b.dataset.ref || card.dataset.sku;
        card.dataset.nombre = (card.dataset.base || card.dataset.nombre) + " " + b.dataset.color;
        if (b.dataset.mini) card.dataset.img = b.dataset.mini;

        var hermanos = card.querySelectorAll('[data-a="color"]');
        for (var i = 0; i < hermanos.length; i++) hermanos[i].classList.remove("on");
        b.classList.add("on");

        var rot = card.querySelector("[data-color-activo]");
        if (rot) rot.textContent = b.dataset.color;

        var badge = card.querySelector(".cmu-badge");
        var n = parseInt(b.dataset.stock || "0", 10);
        if (badge && b.dataset.stock) {
          badge.className = "cmu-badge" + (n > 20 ? " stock" : (n > 0 ? " bajo" : ""));
          badge.textContent = n > 20 ? "● En bodega" : (n > 0 ? "● Últimas " + n : "Bajo pedido");
        }
        return;
      }

      if (b.dataset.a === "mas") {
        var abierta = card.classList.toggle("abierta");
        b.setAttribute("aria-expanded", abierta);
        return;
      }
      if (b.dataset.a === "cotizar") {
        agregar(card.dataset.sku, {
          nombre: card.dataset.nombre,
          img: card.dataset.img,
          url: card.dataset.url || ""
        });
      }
    });
  });

  window.CORMU_COT = { agregar: agregar, quitar: quitar, abrir: abrir, lista: function () { return lista; } };
})();
